import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './title.css'

const Title = (props) => {
  return (
    <div id={props.titleId} className="title-thq-title-elm">
      <span className="title-text1">
        {props.text ?? (
          <Fragment>
            <span className="title-text4">
              Permitenos facilitarte las cosas
            </span>
          </Fragment>
        )}
      </span>
      <span className="title-text2">
        {props.text1 ?? (
          <Fragment>
            <span className="title-text3">
              Nuestros agentes automatizan casi cualquier proceso y se integran
              con el 99% de las herramientas del mercado.
            </span>
          </Fragment>
        )}
      </span>
    </div>
  )
}

Title.defaultProps = {
  text1: undefined,
  titleId: '',
  text: undefined,
}

Title.propTypes = {
  text1: PropTypes.element,
  titleId: PropTypes.string,
  text: PropTypes.element,
}

export default Title
